import classNames from 'classnames';
import { ButtonAsA } from '../Button/ButtonAsA';
import type { Tab } from './useTabs';
import './LegacyTabs.css';
import { Button } from '@ipfabric/ui-components/Button/Button';
import type { JSX, MouseEvent } from 'react';

interface Props<TKey> {
  activeTab: TKey | null;
  tabs: readonly Tab<TKey>[];
  stretch?: boolean;
  onChangeTab: (key: TKey) => void;
  showAddButton?: boolean;
  onAddTabClick?: (e: MouseEvent<HTMLButtonElement>) => void;
}

export const LegacyTabs = <TKey extends string = string>(
  props: Props<TKey>,
): JSX.Element => {
  const handleTabClick = (tab: Tab<TKey>) => {
    if (!tab.disabled) {
      props.onChangeTab(tab.key);
    }
  };

  return (
    <ul className='nav nav-tabs flex w-full'>
      {props.tabs.map((tab, index) => (
        <li
          className={classNames(
            'list-none',
            props.stretch && 'flex-1',
            tab.key === props.activeTab && 'active',
            index === props.tabs.length - 1 && 'tab-view__tab--last',
          )}
          key={tab.key}
        >
          <ButtonAsA
            className={classNames(
              'h-full select-none text-center',
              tab.disabled && 'disabled',
            )}
            draggable={false}
            onClick={() => {
              handleTabClick(tab);
            }}
          >
            {tab.label}
          </ButtonAsA>
        </li>
      ))}
      {props.showAddButton && (
        <li className='list-none self-center pl-1'>
          <Button
            onClick={props.onAddTabClick}
            icon='fa-plus'
            renderAs='button'
            variant='plain'
            size='default'
          >
            New tab
          </Button>
        </li>
      )}
    </ul>
  );
};
